import React, { useMemo } from "react";
import { getFormValues } from "redux-form";
// import { isDirty, getFormValues, destroy, initialize, getFormInitialValues } from "redux-form";
import { useSelector } from "react-redux";

import {
	SocialPreview
	// ProgressIndicator
} from "rhombus-react";

import { API_URL } from "utils/constants";
import { getSocialValuesFromVariables } from "widgets/social2/utils";

const EDIT_SOCIAL_VERSION = "editSocialVersion";
const FVS = getFormValues(EDIT_SOCIAL_VERSION);

export default function InlineVersionPreview(props){
	let currentCreative = useSelector((state) => {
			return state.creativeDetails;
		})
		, editValues = useSelector(FVS)
		;

	let updatedSocialValues = useMemo(() => {
		return getSocialValuesFromVariables(currentCreative.socialValues, editValues, currentCreative.creativeLibraryId, currentCreative.adType);
	}, [currentCreative, editValues]);

	let previewProps = {
		libraryId:currentCreative.creativeLibraryId,
		creativeId:currentCreative.id,
		// filename,
		// adTypeClass,
		socialValues:updatedSocialValues,
		isLoaded:true,
		adType:currentCreative.adType,
		// placementType: format,
		baseDomain: API_URL,
	};

	return (
		<aside className="social-version-preview">
			<SocialPreview {...previewProps} className="rhombus-preview-container" />
		</aside>
	);
}
